import React, { useEffect, useState } from 'react';
import SignaturePresentational from './signaturePresentational';

const SignatureFunctional = ({ allowNavigate, buttonMode }) => {
	useEffect(() => {
		allowNavigate?.(2);
		buttonMode?.('dual');
	}, []);
	return (
		<>
			<SignaturePresentational></SignaturePresentational>
		</>
	);
};

export default SignatureFunctional;
